import { useQuery } from "react-query";
import { API_URL } from "../api";
import { APIError, APIResponse, get } from "../api";

export type ReferralRewardMeta = {
  voucherKind?: "DATA" | "AIRTIME";
  network?: string;
  planCode?: string;
  planName?: string;
  [k: string]: unknown;
};

export type ReferralReward = {
  id: string;
  role: "REFERRER" | "REFEREE";
  rewardType: "CASH" | "VOUCHER";
  amount: number | null;
  currency: string | null;
  rewardMeta: ReferralRewardMeta | null;
  status: string;
  claimable: boolean;
  voucherCode: string | null;
  createdAt: string;
  claimedAt: string | null;
  fulfilledAt: string | null;
};

export type ReferralRewardsData = {
  items: ReferralReward[];
  total: number;
  skip: number;
  take: number;
};

export function useReferralRewards(
  params: { skip?: number; take?: number; status?: string } = {}
) {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const skip = params.skip ?? 0;
  const take = params.take ?? 20;
  const statusQ = params.status ? `&status=${encodeURIComponent(params.status)}` : "";

  return useQuery<APIResponse<ReferralRewardsData>, APIError>({
    queryKey: ["referral-rewards", token, skip, take, params.status ?? ""],
    queryFn: () =>
      get(
        `${API_URL}/user/account/referrals/rewards?skip=${skip}&take=${take}${statusQ}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ),
    enabled: !!token,
    retry: false,
    staleTime: 1000 * 30,
  });
}
